import { Paper, Icon } from '@safedns/skydns-ui-react-lib';

import { BASE_URL, useGetAgentsChangelogQuery } from '../../services/ADapi';

import sprite from '../../icons/sprite.svg';
import ChangelogCard from './ChangelogCard';
import OldChangelogCard from './OldChangelogCard';
import styles from './Releases.module.scss';

function getDownloadLink(agentType, version) {
  if (agentType === 'linux') {
    // Temporarily disable download link for Linux agent until we have a new version
    // return `/downloads/skydns-agent-${version}-x86_64.deb`;
    return;
  }

  return `${BASE_URL}/agents/rest_api/v1/build/download/`;
}

const iconStyle = {
  marginRight: 8,
  fontSize: '1rem',
  color: '#C2CFE0',
};

const map = {
  linux: {
    title: 'SkyDNS agent для Linux',
    icon: (
      <Icon
        id="linux"
        sprite={sprite}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        sx={iconStyle}
      />
    ),
  },
  windows: {
    title: 'SkyDNS agent для Windows',
    icon: (
      <Icon
        id="windows"
        sprite={sprite}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        sx={iconStyle}
      />
    ),
  },
};

const Releases = () => {
  const { data } = useGetAgentsChangelogQuery();

  const windowsChangelogs = data?.[0][1] ?? [];
  const linuxChangelogs = data?.[1][1] ?? [];

  return (
    <>
      <Paper title="Агент" sx={{ marginBottom: '24px' }}>
        <div className={styles.agentContainer}>
          {data?.map((agent) => {
            const agentType = agent[0];
            const releases = agent[1];

            return (
              <ChangelogCard
                key={agentType}
                agentType={agentType}
                title={map[agentType].title}
                agentVersion={releases[0]?.agent_version}
                changelog={releases[0]?.changelog}
                downloadLink={getDownloadLink(
                  agentType,
                  releases[0]?.agent_version
                )}
              />
            );
          })}
        </div>
      </Paper>
      <Paper title="Прошлые версии агента">
        <div className={styles.oldVersionsGrid}>
          {windowsChangelogs.map((release, i) => {
            const agentType = data[0][0];
            const icon = map[agentType].icon;

            if (i === 0) {
              return null;
            }

            return (
              <OldChangelogCard
                key={agentType + release.release_date + release.agent_version}
                icon={icon}
                agentType={agentType}
                agentVersion={release.agent_version}
                releaseDate={release.release_date}
                changelog={release.changelog}
              />
            );
          })}
        </div>
        <div className={`${styles.oldVersionsGrid} ${styles.oldVersionsGridLinux}`}>
          {linuxChangelogs.map((release, i) => {
            const agentType = data[1][0];
            const icon = map[agentType].icon;

            if (i === 0) {
              return null;
            }

            return (
              <OldChangelogCard
                key={agentType + release.release_date + release.agent_version}
                icon={icon}
                agentType={agentType}
                agentVersion={release.agent_version}
                releaseDate={release.release_date}
                changelog={release.changelog}
              />
            );
          })}
        </div>
      </Paper>
    </>
  );
};

export default Releases;

